/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".column-center .mat-sort-header-container{justify-content:center}  .column-center button{display:inline-block;width:99%;text-align:center!important}"];
export { styles as styles };
